'use client'
import { CheckboxIcon } from '@/_assets/icon-components'
import { useCustomLocale } from '@/_hooks/useCustomLocale'
import {
  RadioCardItem,
  RadioCardLabel,
  RadioCardRoot,
} from '@/components/ui/radio-card'
import { Box, HStack, Stack, Tabs, Text } from '@chakra-ui/react'

function OriginOptions({
  originProps,
  activeOptions,
  productVariants,
  onOptionChange,
}: any) {
  const currentLocale = useCustomLocale()

  const handleLabelClick = (selectedValue: string, idx: number) => {
    onOptionChange(selectedValue, idx)
  }

  return (
    originProps?.length > 0 && (
      <Stack gap={6} mt={{ base: 3, lg: 0 }}>
        {originProps?.map((property: any, idx: number) =>
          property.view_type === 'tab' ? (
            <Box key={property.id}>
              <Text fontSize='sm' fontWeight={600} mb={3}>
                {property.title?.[currentLocale]}
              </Text>
              <Tabs.Root
                variant='enclosed'
                fitted
                h={'46px'}
                value={activeOptions[idx]}
                onValueChange={(e: any) => {
                  onOptionChange(e.value, idx)
                }}
                overflowX={'scroll'}
                display={'flex'}
                scrollbar={'hidden'}
                w={'full'}
              >
                <Tabs.List rounded={12} bg='background' color='text'>
                  {property.options.map((option: any) => (
                    <Tabs.Trigger
                      whiteSpace={'nowrap'}
                      rounded={8}
                      key={option.id}
                      color='text'
                      _selected={{ bg: 'background.card' }}
                      value={option.id}
                    >
                      {option.title?.[currentLocale]}
                    </Tabs.Trigger>
                  ))}
                </Tabs.List>
              </Tabs.Root>
            </Box>
          ) : (
            <RadioCardRoot
              unstyled
              key={property.id}
              aria-labelledby={property.title.en}
              value={activeOptions[idx]}
              onValueChange={(e: any) => {
                onOptionChange(e.value, idx)
              }}
            >
              <RadioCardLabel fontSize='sm' fontWeight={600} mb={2} display='block'>
                {property.title?.[currentLocale]}
              </RadioCardLabel>
              <Stack gap={2}>
                {property?.options?.map((option: any) =>
                  idx !== 0
                    ? Object.keys(productVariants).some((item) =>
                      item.includes(
                        idx == 1
                          ? activeOptions[0] + '_' + option.id
                          : idx == 2
                            ? activeOptions[0] +
                            '_' +
                            activeOptions[1] +
                            '_' +
                            option.id
                            : activeOptions[0] +
                            '_' +
                            activeOptions[1] +
                            '_' +
                            activeOptions[2] +
                            '_' +
                            option.id
                      )
                    ) && (
                      <HStack
                        w={'full'}
                        id={option.id}
                        onClick={() => {
                          handleLabelClick(option.id, idx)
                        }}
                        flexDir={'row-reverse'}
                        justifyContent={'space-between'}
                        key={option.id}
                        fontSize={'sm'}
                        bg='background'
                        rounded='lg'
                        p={3}
                      >
                        <RadioCardItem
                          icon={
                            option.id === activeOptions[idx] ? (
                              <CheckboxIcon color={'var(--primary-default)'} />
                            ) : (
                              <Box
                                bg={'white'}
                                w={7}
                                h={7}
                                rounded={'full'}
                              />
                            )
                          }
                          value={option.id}
                          id={option.id}
                          indicator={false}
                          border={'none'}
                        />
                        <label htmlFor={option.id}>
                          {option.title?.[currentLocale]}
                        </label>
                      </HStack>
                    )
                    : idx == 0 &&
                    Object.keys(productVariants).some((item) =>
                      item.split('_').includes(option.id)
                    ) && (
                      <HStack
                        as={'label'}
                        w={'full'}
                        id={option.id}
                        flexDir={'row-reverse'}
                        justifyContent={'space-between'}
                        onClick={() => {
                          handleLabelClick(option.id, idx)
                        }}
                        key={option.id}
                        fontSize={'sm'}
                        bg='background'
                        rounded='lg'
                        p={3}
                      >
                        <RadioCardItem
                          icon={
                            option.id === activeOptions[idx] ? (
                              <CheckboxIcon color={'var(--primary-default)'} />
                            ) : (
                              <Box
                                bg={'white'}
                                w={7}
                                h={7}
                                rounded={'full'}
                              />
                            )
                          }
                          value={option.id}
                          id={option.id}
                          indicator={false}
                          border={'none'}
                        />
                        <label htmlFor={option.id}>
                          {option.title?.[currentLocale]}
                        </label>
                      </HStack>
                    )
                )}
              </Stack>
            </RadioCardRoot>
          )
        )}
      </Stack>
    )
  )
}

export default OriginOptions
